import ComponentsManager from "controllers/ComponentsManager";
import BigTitle from './BigTitle';


export default new class {
	constructor() {
		ComponentsManager.register('title', BigTitle);
	}
}
